import { Toast } from 'vant'
// import 'vant/lib/toast/style'
export default {
  mixin: {
    data() {
      return {
        requestKey: 0, //自增
        taskTag: 'taskcenter:',
        targetCode: null, //任务对象值
        targetId: null, //任务对象ID,如文章id，专栏id，社群id等
        taskCode: null, //mcode
        maps: {
          '/doc/': { targetCode: 'mdoc', canBeCompleted: false },
          '/live/': { targetCode: 'mlive', canBeCompleted: false },
          '/columnList56': { targetCode: 'mcol', canBeCompleted: true },
          '/column/': { targetCode: 'mcol', canBeCompleted: false },
          '/OuterLinkPage': { targetCode: 'mElink', canBeCompleted: true },
        },
        taskConditions: [], //任务条件
        waitForTaskConditions: true, //true:等待任务条件返回再执行逻辑；false:任务提交接口请求结束，不再等待;
        taskStayProps: {
          show: false,
          visible: false, //带mcode时显示倒计时,不带mcode，隐藏显示计时仍进行
          time: 0, //单位 毫秒
          autoStart: false,
        },
        taskCanBeCompleted: true, //是否可以完成,主要用于控制一些带权限的页面,没有权限时，则不能完成任务
        timeoutId: undefined,
      }
    },
    components: { [Toast.name]: Toast },
    created() {},
    mounted() {},
    methods: {
      showToast(text) {
        Toast.success({ message: text, icon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-prod.liangyihui.net/boss-upload/ylxqd1dWTKdLvrmtLY5M7Q/HB65XWE4jd2ko3Lf.png' })
      },
      showToastFail(text) {
        //失败的统一不提示
        // Toast.fail(text)
      },
      /**
       * 获取任务条件,需要登录状态
       */
      async getTaskCondititons() {
        if (!window.head.auth) {
          return
        }
        const postData = {
          head,
        }
        if (this.targetCode) {
          postData.targetCode = this.targetCode
        }
        if (this.targetId) {
          postData.targetId = this.targetId
        }
        if (this.taskCode) {
          postData.taskCode = decodeURIComponent(this.taskCode)
        }
        const response = await this.$api.getTaskCondititons(postData)
        const res = response.data
        this.waitForTaskConditions = false
        if (res.responseStatus && res.responseStatus.ack == 0) {
          this.taskConditions = res.taskConditions
          this.waitForTaskConditions = false
          this.taskConditions.forEach((item) => {
            //如果是外链对象，则发送链接到监听页面
            if (item.missionTarget == 'mElink') {
              eventHub.$emit('getOuterLink', { link: item.transitLink, title: item.taskTitle })
            }
          })
        } else if (res.responseStatus && res.responseStatus.ack != 0) {
          this.showToastFail(res.responseStatus.errormessage)
        }
      },
      /**
       * 完成任务逻辑处理
       * @param condition String|Object
       */
      async completeTaskCondititons(condition) {
        if (!this.taskCanBeCompleted) {
          console.log('任务无法完成,没有权限')
          return
        }
        let conditionCode, conditionValue
        if (Object.prototype.toString.call(condition) === '[object Object]') {
          conditionCode = condition.conditionCode
          conditionValue = condition.conditionValue
        } else if (Object.prototype.toString.call(condition) === '[object String]') {
          conditionCode = condition
          conditionValue = null
        } else {
          console.log('任务完成', `参数错误${condition}`)
          return
        }
        console.log('任务完成', conditionCode, conditionValue, this.taskConditions)
        this.taskConditions.forEach((item) => {
          item.completedConditions.forEach((i) => {
            if (i.conditionCode == conditionCode) {
              if (conditionCode == 'c_cmnt') {
                if (conditionValue && conditionValue >= i.conditionValue) {
                  //完成评论任务
                  this.setTaskDoneMission(item.taskCode)
                }
              } else {
                //完成其他任务
                console.log('完成其他任务---')
                this.setTaskDoneMission(item.taskCode)
              }
            }
          })
        })
      },
      /**
       * 调用完成任务接口,需要登录状态
       * @param {*} taskCode
       */
      async setTaskDoneMission(taskCode) {
        if (!window.head.auth) {
          return
        }
        const postData = {
          head,
        }
        postData.userType = 1
        /*
         * 请求随机数，防止请求重复提交
         */
        postData.requestRandom = Date.now().toFixed(0) + ++this.requestKey
        if (this.targetId) {
          postData.associationId = this.targetId
        }
        if (taskCode) {
          postData.taskCode = taskCode
        }
        /* start 如果url里带page_source，则触发埋点 */
        let pageSource = getSearchParams(window.location.href, 'page_source')
        if (!pageSource) {
          pageSource = getSearchParams(window.location.href, 'task_page_source')
        }
        
        if (pageSource) {
          postData.buriedPoints = [
            {
              eventName: 'TaskFinish',
              propertiesMap: {
                page_source: pageSource,
              },
            },
          ]
        }
        /* end 如果url里带page_source，则触发埋点 */
        const response = await this.$api.setTaskDoneMission(postData)
        const res = response.data
        if (res && res.responseStatus && res.responseStatus.ack == 0) {
          if (res.rewardMessage) {
            this.showToast(`${res.rewardMessage}`)
          }

          // this.showToast(`${res.rewardType == 1 ? '积分' : '劵码'}+${res.gainScore}`)
        } else if (res && res.responseStatus && res.responseStatus.ack != 0) {
          this.showToastFail(res.responseStatus.errormessage)
        }
      },
      /**
       * 页面加载完成手动触发,按需显示倒计时
       */
      pageLoaded() {
        if (!this.taskCanBeCompleted) {
          // console.log('任务浏览暂停,没有权限')
          return
        }
        // console.log('pageLoaded', this.taskConditions)
        if (this.taskConditions && this.taskConditions.length > 0) {
          this.taskConditions.forEach((item) => {
            item.completedConditions.forEach((i) => {
              if (i.conditionCode == 'c_stay') {
                //如果时长大于0则执行倒计时逻辑，否则直接完成任务
                if (+i.conditionValue) {
                  this.taskStayProps.show = true
                  this.taskStayProps.visible = this.taskCode ? true : false
                  this.taskStayProps.time = parseInt(+i.conditionValue) * 1000
                  this.taskStayProps.autoStart = true
                } else {
                  this.finishStayTask()
                }
              }
            })
          })
        } else {
          this.timeoutId = setTimeout(() => {
            if (this.waitForTaskConditions) {
              this.pageLoaded()
            }
          }, 1000)
        }
      },
      videoLoaded() {
        if (this.taskConditions && this.taskConditions.length > 0) {
          this.taskConditions.forEach((item) => {
            item.completedConditions.forEach((i) => {
              if (i.conditionCode == 'v_w') {
                eventHub.$emit('viewVideo', { taskType: item.taskType, time: i.conditionValue * 1000 }) //秒转毫秒
              }
            })
          })
        } else {
          this.timeoutId = setTimeout(() => {
            if (this.waitForTaskConditions) {
              this.videoLoaded()
            }
          }, 1000)
        }
      },
      /**
       * 倒计时结束，提交结果
       */
      finishStayTask() {
        // console.log('倒计时结束')
        this.completeTaskCondititons('c_stay')
      },
      /**
       * @param conditionCode 条件code 忽略[c_stay]停留时长自动处理
       */
      finishTaskByConditionCode(conditionCode) {
        this.completeTaskCondititons(conditionCode)
      },
      /**
       * 带指定targetId
       * @param {*} conditionCode
       * @param {*} targetId
       */
      finishTaskByConditionCode(conditionCode, targetId) {
        this.targetId = targetId
        this.completeTaskCondititons(conditionCode)
      },
      finishTaskComment(comment) {
        if (comment) {
          this.completeTaskCondititons({ conditionCode: 'c_cmnt', conditionValue: comment.length })
        }
      },
      finishTaskViewVideo() {
        this.completeTaskCondititons('v_w')
      },
      /**
       * 路由变化时,重置所有状态
       */
      reset() {
        clearTimeout(this.timeoutId)
        this.clearProps()
        this.targetCode = null
        this.targetId = null
        this.taskCode = null
        this.taskConditions = []
        this.waitForTaskConditions = true
        this.taskCanBeCompleted = true
      },
      /**
       * 重置倒计时
       */
      clearProps() {
        this.taskStayProps.show = false
        this.taskStayProps.visible = false
        this.taskStayProps.time = 0
        this.taskStayProps.autoStart = false
      },
    },
    computed: {},
    watch: {
      taskCanBeCompleted(newVal, oldVal) {
        if (newVal) {
          this.pageLoaded()
        }
      },
      $route(to, from) {
        this.reset()
        const id = parseInt(this.$route.params.id)
        this.targetId = id
        const keys = to.path.match(new RegExp(/\/doc\/|\/live\/|\/columnList56|\/column\/|\/OuterLinkPage/, 'g'))
        // const keys = to.path.match(new RegExp(/((?:[^\/]+?).+(?=\/))/, 'g'))
        if (keys && keys.length) {
          this.targetCode = this.maps[keys[0]].targetCode
          this.taskCanBeCompleted = this.maps[keys[0]].canBeCompleted
          this.taskCode = getMCode(window.location.href)
          // if (this.taskCode) {
          //   const pageSources = this.taskCode.split('_')
          //   // const pageSources = this.taskCode.match(new RegExp(/\w+(?=\_\|)/,'g'))
          //   if (pageSources && pageSources.length) {
          //     this.pageSource = pageSources[0]
          //   } else {
          //     this.pageSource = null
          //   }
          // }

          if (this.targetCode || this.taskCode) {
            this.getTaskCondititons()
            // console.log(`${this.taskTag}任务对象=${this.targetCode},任务对象id=${this.targetId},mcode=${this.taskCode}`)
          }

          if ((keys[0] == '/doc/' || keys[0] == '/live/') && window.location.search.includes('avtivityType=2025under35')) {
            this.taskCode = getMCode(window.location.href)
            this.setTaskDoneMission(this.taskCode)
          }
        } else if (to.path != '/tools/DoctorToolsIndex' && to.path.match(new RegExp(/\/tools/, 'g')) && getMCode(window.location.href)) {
          // 医学工具的任务, 且链接中有 mcode，那么需要走完成任务的接口
          console.log('task-center-----toos-----', to.path)

          if (window.location.search.includes('avtivityType=2025under35')) {
            this.taskCode = getMCode(window.location.href)
            this.setTaskDoneMission(this.taskCode)
          } else {
            this.targetCode = null
          }
        } else {
          this.targetCode = null
        }
      },
    },
  },
}
